export default __webpack_public_path__ + "static/media/get-api.3ad4235b.svg";